
















import dialog from '@/dialog/Dialog.vue'
import textfield from '@/form/Textfield.vue'
import { mapState } from 'vuex'

export default {
  name: 'OptionEditDialog'

  props: [
    'id'
    'option'
    'prop'
    'group'
  ]

  data: () ->
    o: {}

  components:
    'v-dialog': dialog
    'v-textfield': textfield

  methods:
    ok: () ->
      @$emit 'ok', @o
    cancel: () -> 
      @$emit 'cancel', false

  computed:
    mapState
      show: (state) ->
        if state.dialog == @id
          @o = _.cloneDeep @option

        state.dialog
   
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/dialog/OptionEdit.vue